enum GrilleType {
    Linear = 1,
    Perforated = 2,
    JBead = 5
}
export default GrilleType;